import React, { useMemo } from 'react'
import { createBehavior, createResource } from '@designable/core'
// import { Form as FormilyForm } from '@formily/antd'
import { DnFC } from '@designable/react'
import { AllLocales } from '../../locales'
import './styles.less'
import { AllSchemas } from '../../schemas'
import { Form as FormilyForm } from './Form'

interface FromProps {
  showNav?: boolean;
  navBarProps: any;
  showSideBar?: boolean;
  sideBarProps: any;
  showTabBar?: boolean;
  tabBarProps: any;
}

export const Form: DnFC<React.ComponentProps<typeof FormilyForm>> = FormilyForm

Form.Behavior = createBehavior({
  name: 'Form',
  selector: (node) => node.componentName === 'Form',
  designerProps(node) {
    return {
      draggable: !node.isRoot,
      cloneable: !node.isRoot,
      deletable: !node.isRoot,
      droppable: true,
      propsSchema: AllSchemas.Form,
      defaultProps: {
        style: {
          padding: '0px'
        },
        showNav: false,
        showSideBar: false,
        showTabBar: false,
        navBarProps: {
          title: "标题",
          style: {
            background: "#ffffff"
          }
        },
        sideBarProps: {
          tabs: [{ title: '菜单一', key: "1" }, { title: '菜单二', key: '2' }],
        },
        tabBarProps: {
          tabs: [
            {
              key: 'home',
              title: '首页',
              iconName: "AppOutline",
            },
            {
              key: 'todo',
              title: '待办',
              iconName:  "UnorderedListOutline",
              badge: '2'
            },
            {
              key: 'message',
              title: '消息',
              iconName: "MessageOutline",
              badge: '99+'
            },
            {
              key: 'me',
              title: '我的',
              iconName: "UserOutline",
            },        
          ],
          style: {
            background: "#ffffff"
          }
        }
      },
    };
  },
  designerLocales: AllLocales.Form,
})

Form.Resource = createResource({
  title: { 'zh-CN': '表单', 'en-US': 'Form' },
  icon: 'FormLayoutSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'object',
        'x-component': 'Form',
      },
    },
  ],
})
